import React, { useState, useEffect } from 'react';
import { Modal, Box, CircularProgress, Stack } from '@mui/material';
import { styled } from '@mui/system';
import TabNavigation from '../Tabs';
import TextView from '../../TextView';
import StorageStatusContainer from '../StorageStatusContainer';
import Button from '../../Button';
import { Overlay } from '../StorageStatusContainer/StorageStatusContainer.styled';
import CleanupModal from '../CleanupModal';
import { ASSETS } from '../../../utils/config';
import { getTotalStorage } from '../../../services/api';
import { useSelector, useDispatch } from 'react-redux';
import { setStorage } from '../../../redux/reducers/storage';
import StorageTable from '../StorageTable';
import { toast } from 'react-toastify';
import StorageMediaModal from '../StorageMediaModal';
import DowngradeHeader from './DowngradeHeader';

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled(Box)`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  text-align: center;
  height: 85vh;
  width: 65vw;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  &::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
  }
`;

const StickyFooter = styled(Stack)`
  position: sticky;
  bottom: 0;
  background-color: white;
  padding: 15px;
  box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);

`;

export const CancelButton = styled(TextView)`
  font-size: 16px;
  line-height: 20px;
  color: #495057;
  cursor: pointer;
  margin-right:10px
`

const DowngradeModal = ({
    isOpen = false,
    onClose = () => { },
    downgradeType = 0,
}) => {
    //  can be 0=free,1=essential,2=premium

    const [cleanupModal, setCleanupModal] = useState(false);
    const [loading, setLoading] = useState(true); // Add loading state
    const [isMediaModalOpen, setIsMediaModalOpen] = useState(false);

    const dispatch = useDispatch();

    const {
        storageLimit,
        storageUsed,
        storageUsedPercentage,
    } = useSelector((state) => state.storage);


    const fetchMedia = async () => {
        try {
            const response = await getTotalStorage();
            console.log('sitass', response.data.data);

            dispatch(setStorage(response.data.data)); // Dispatch setStorage action
        } catch (err) {
            console.error('Failed to fetch Media:', err);
        } finally {
            setLoading(false); // Set loading to false once data is fetched
        }
    };

    useEffect(() => {
        fetchMedia();
    }, [dispatch]);

    const [selectedWheel, setSelectedWheel] = useState({});

    const renderTabContent = () => {
        return <StorageTable type="wheels" fetchMedia={fetchMedia} calculateSize={true} onEditClick={(data) => {
            setSelectedWheel(data)
            setIsMediaModalOpen(true)
        }} />;
    };

    return (
        <StyledModal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <ModalContent>
                <Stack style={{ padding: '25px', paddingBottom: '0px' }}>
                    <DowngradeHeader onClose={onClose} downgradeType={downgradeType} />

                    {loading ? (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100vh',
                            }}
                        >
                            <CircularProgress />
                        </div>
                    ) : (
                        <>
                            <StorageStatusContainer
                                showTitle={false}
                                storageUsed={storageUsed}
                                storagePercent={storageUsedPercentage}
                                totalStorage={storageLimit}
                            />

                            {/* <Stack
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            my={1}
            style={{ width: '100%', padding: '15px', gap: '10px' }}
        >
            <TextView style={{
                fontSize: '20px',
                lineHeight: '30px',
                fontWeight: '600',
                color: 'black',
            }} >My Wheels</TextView>
            <Button width={'220px'} onClick={() => toast.success('Move to upgrade page')}>Cleanup</Button>
        </Stack> */}
                            <div style={{ height: '10px' }}></div>
                            {renderTabContent()}

                            <StorageMediaModal isOpen={isMediaModalOpen} onClose={() => setIsMediaModalOpen(false)} wheelId={selectedWheel?.id} title={selectedWheel?.name} />
                        </>
                    )}
                    {cleanupModal && (
                        <>
                            <Overlay onClick={() => setCleanupModal(false)} />
                            <CleanupModal
                                onClose={() => setCleanupModal(false)}
                                storageUsed={storageUsed}
                                storagePercent={storageUsedPercentage}
                                totalStorage={storageLimit}
                            />
                        </>
                    )}
                </Stack>
                <StickyFooter display={"flex"} flexDirection={"row"} justifyContent={'space-between'} alignItems={'center'} style={{ marginTop: '20px' }}>
                    <Button width={'220px'} onClick={(e) => {
                        e.stopPropagation();
                        setCleanupModal(true)
                    }}>Cleanup</Button>

                    <Stack display={"flex"} flexDirection={"row"} justifyContent={'flex-end'} alignItems={'center'} >
                        <CancelButton onClick={() => { }}>Cancel</CancelButton>
                        <div style={{ width: '170px' }}>
                            <Button isLoading={false} type="Downgrade" disabled={false}>
                                Confirm Downgrade
                            </Button>
                        </div>
                    </Stack>
                </StickyFooter>
            </ModalContent>
        </StyledModal>
    );
};

export default DowngradeModal;
